import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

// Determine base URL based on the environment
export const BASE_URL: string = window.location.hostname.includes("s3")
  ? "https://www.nepmaster.com" // Replace with your production URL
  : "https://nepmaster.com"; // Localhost URL

// Create an Axios instance with the base URL
const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Define the API utility methods
const ApiUtil = {
  get: <T>(url: string, params: Record<string, any> = {}): Promise<AxiosResponse<T>> =>
    api.get<T>(url, { params }),

  post: <T>(url: string, data: Record<string, any> = {}): Promise<AxiosResponse<T>> =>
    api.post<T>(url, data),

  put: <T>(url: string, data: Record<string, any> = {}): Promise<AxiosResponse<T>> =>
    api.put<T>(url, data),

  delete: <T>(url: string, params: Record<string, any> = {}): Promise<AxiosResponse<T>> =>
    api.delete<T>(url, { params }),
};

export default ApiUtil;
